import axios from 'axios';
import _URL from '../URL/index';
const limit = 15

export default {
    services: {
        getStatsCard: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/statscard?filter=${filter}&start=${start}&end=${end}`)
        },
        GetLineReservation: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/linereservation?filter=${filter}&start=${start}&end=${end}`)
        },
        GetPieChart: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/piechart?filter=${filter}&start=${start}&end=${end}`)
        },
        getHistograms: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/histograms?filter=${filter}&start=${start}&end=${end}`)
        },
        getStatusList: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/status?filter=${filter}&start=${start}&end=${end}`)
        },
        getTopsSuppliers: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/tops?filter=${filter}&start=${start}&end=${end}`)
        },
        getTopsCountries: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/tops/countries?filter=${filter}&start=${start}&end=${end}`)
        },
        getIncome: (filter, start, end) => {
            return axios.get(`${_URL._API}/dashboard/income/?filter=${filter}&start=${start}&end=${end}`)
        },
    }
}